import { Routes, Route, Navigate } from 'react-router-dom';
import SuspenseLoader from './views/components/SuspenderLoader/SuspenseLoader';
import { lazy, Suspense } from 'react';
import { RoutesEnum } from './constants/EndpointEnum';

const Loader = (Component: any) => (props: any) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const Home = Loader(lazy(() => import('./views/pages/Home')));
const ApiSpecifications = Loader(lazy(() => import('./views/pages/api/ApiSpecifications')));
const Main = Loader(lazy(() => import('./views/pages/Home').then((module) => ({ default: module.Main }))));
const FilePage = Loader(lazy(() => import('./views/pages/fileservice/FilePage')));

function Router() {
  return (
    <Routes>
      <Route path={RoutesEnum.home} element={<Home />}>
        <Route index element={<Navigate to={RoutesEnum.main} replace />} />
        <Route path={RoutesEnum.main} element={<Main />} />
        <Route path={RoutesEnum.apiSpecifications} element={<ApiSpecifications />} />
         <Route path={RoutesEnum.files} element={<FilePage />} />
      </Route>
      <Route path={RoutesEnum.home} element={<Home />} />
    </Routes>
  );
}

export default Router;
